import type { DealerState } from '@makemydeal/dr-dash-types';

import { UPDATE_DEALER } from '../reducers/dealerReducer';
import { SAVE_DEALERSHIP_SELECTION } from '../actionTypes/dealershipSelectionActionTypes';
import type { Dealership } from '../reducers/dealershipsReducer';

export const updateDealer = (dealer: Partial<DealerState>) => ({
    type: UPDATE_DEALER,
    payload: dealer
});

export const saveDealershipSelection = (selectedDealer: Dealership) => ({
    type: SAVE_DEALERSHIP_SELECTION,
    payload: selectedDealer
});
